const List = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 8.5C6 9.32843 5.32843 10 4.5 10C3.67157 10 3 9.32843 3 8.5C3 7.67157 3.67157 7 4.5 7C5.32843 7 6 7.67157 6 8.5Z"
        fill="#202023"
      />
      <path
        d="M6 12.5C6 13.3284 5.32843 14 4.5 14C3.67157 14 3 13.3284 3 12.5C3 11.6716 3.67157 11 4.5 11C5.32843 11 6 11.6716 6 12.5Z"
        fill="#202023"
      />
      <path
        d="M6 16.5C6 17.3284 5.32843 18 4.5 18C3.67157 18 3 17.3284 3 16.5C3 15.6716 3.67157 15 4.5 15C5.32843 15 6 15.6716 6 16.5Z"
        fill="#202023"
      />
      <path
        d="M7.99995 7.69995C7.55812 7.69995 7.19995 8.05812 7.19995 8.49995C7.19995 8.94178 7.55812 9.29995 7.99995 9.29995H20C20.4418 9.29995 20.8 8.94178 20.8 8.49995C20.8 8.05812 20.4418 7.69995 20 7.69995H7.99995Z"
        fill="#202023"
      />
      <path
        d="M7.99995 11.7C7.55812 11.7 7.19995 12.0581 7.19995 12.5C7.19995 12.9418 7.55812 13.3 7.99995 13.3H20C20.4418 13.3 20.8 12.9418 20.8 12.5C20.8 12.0581 20.4418 11.7 20 11.7H7.99995Z"
        fill="#202023"
      />
      <path
        d="M7.99995 15.7C7.55812 15.7 7.19995 16.0581 7.19995 16.5C7.19995 16.9418 7.55812 17.3 7.99995 17.3H20C20.4418 17.3 20.8 16.9418 20.8 16.5C20.8 16.0581 20.4418 15.7 20 15.7H7.99995Z"
        fill="#202023"
      />
    </svg>
  );
};

export default List;
